/** Form-cache UI 可觀察狀態（handoff UI States）。 */
export const FORM_CACHE_UI_STATUS = {
  IDLE: 'IDLE',
  LOCAL_SAVED: 'LOCAL_SAVED',
  SYNCING: 'SYNCING',
  SERVER_SYNCED: 'SERVER_SYNCED',
  SYNC_FAILED: 'SYNC_FAILED',
  CONFLICT: 'CONFLICT',
  RESTORE_AVAILABLE: 'RESTORE_AVAILABLE',
  INVALID_AFTER_RESTORE: 'INVALID_AFTER_RESTORE',
  CONSUMED: 'CONSUMED',
};

export const FORM_CACHE_UI_STATUS_LABEL = {
  [FORM_CACHE_UI_STATUS.IDLE]: '',
  [FORM_CACHE_UI_STATUS.LOCAL_SAVED]: '草稿處理中…',
  [FORM_CACHE_UI_STATUS.SYNCING]: '正在儲存草稿…',
  [FORM_CACHE_UI_STATUS.SERVER_SYNCED]: '草稿已暫存',
  [FORM_CACHE_UI_STATUS.SYNC_FAILED]: '草稿同步失敗，請稍後再試',
  [FORM_CACHE_UI_STATUS.CONFLICT]: '衝突請選擇版本',
  [FORM_CACHE_UI_STATUS.RESTORE_AVAILABLE]: '發現未送出的草稿',
  [FORM_CACHE_UI_STATUS.INVALID_AFTER_RESTORE]: '部分選項已失效，必須修正',
  [FORM_CACHE_UI_STATUS.CONSUMED]: '草稿已建立正式單據，請建立新草稿後再編輯',
};

/** 定稿狀態文案最長字數（供 banner max-w-[Nrem]）。 */
export const FORM_CACHE_UI_STATUS_LABEL_MAX_CHARS = Math.max(
  0,
  ...Object.values(FORM_CACHE_UI_STATUS_LABEL).map((label) => [...label].length),
);
